import { render } from "./Folders.vue?vue&type=template&id=e7ef3b1c"
import script from "./Folders.vue?vue&type=script&lang=js"
export * from "./Folders.vue?vue&type=script&lang=js"

import "./Folders.vue?vue&type=style&index=0&id=e7ef3b1c&lang=css"
script.render = render

export default script